import React, { createContext, useState, useContext, ReactNode, useMemo } from 'react';

const LoadingContext = createContext<{
    isLoading: boolean;
    showLoading: () => void | null;
    hideLoading: () => void | null;
}>({
    isLoading: false,
    showLoading: () => {},
    hideLoading: () => {},
});

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }: { children: ReactNode }) => {
    const [isLoading, setIsLoading] = useState(false);

    const showLoading = () => {
        setIsLoading(true);
    };

    const hideLoading = () => {
        setIsLoading(false);
    };

    return (
        <LoadingContext.Provider
            value={useMemo(() => ({ isLoading, showLoading, hideLoading }), [isLoading, showLoading, hideLoading])}
        >
            {children}
        </LoadingContext.Provider>
    );
};
